const NAME = 'QUALTRICS';
const CNameMapping = {
  [NAME]: NAME,
  Qualtrics: NAME,
  qualtrics: NAME,
};

export { NAME, CNameMapping };
